import { render, staticRenderFns } from "./PartnerStatus.vue?vue&type=template&id=5cda3583&"
import script from "./PartnerStatus.vue?vue&type=script&lang=js&"
export * from "./PartnerStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports